import React from 'react';
import AppCard from '@nxsys/components/AppCard';

type ReportSectionProps = {
  title: string;
  children: React.ReactNode;
};

const ReportSection: React.FC<ReportSectionProps> = ({ title, children }) => {
  return (
    <AppCard
      title={title}
      className="ReportSection"
    >
      <div className="flex flex-col gap-2 p-4">{children}</div>
    </AppCard>
  );
};

export default ReportSection;
